<google-map
  height="600px"
  width="100%"
  [center]="center"
  [zoom]="zoom">

  <!-- <map-marker
    *ngFor="let m of markers"
    [position]="m.position"
    [label]="m.label"
    [title]="m.label"
    (mapClick)="locationSelected.emit(m.position)">
  </map-marker> -->

</google-map>
